export default "__VITE_ASSET__1egptiUH__"